<script lang="ts">
import { createEventDispatcher } from "svelte";
import Input from "./Input.svelte";

    export let searchFailMsg = "Senzor nenalezen";
    export let title = "Vyhledat KLT"
    export let removeWhiteSpace = true;
    export let autoFocus = false;
    const WARNING_VISIBILITY_TIME = 2_000;

    const dispatch = createEventDispatcher();

    let activeZoneSearcherInput;
    $: if (autoFocus && activeZoneSearcherInput) activeZoneSearcherInput.focus();
    let activeZoneSearcherInputVal = "";
    let activeZoneSearcherFailTimer = null;

    function newData() {
        const usedVal = removeWhiteSpace ? activeZoneSearcherInputVal.replace(/\s/g,'') : activeZoneSearcherInputVal;
        dispatch('code', usedVal);
        activeZoneSearcherInputVal = '';
    }
    export function showError() {
        activeZoneSearcherFailTimer = setTimeout(() => {
            activeZoneSearcherFailTimer = null;
        }, WARNING_VISIBILITY_TIME);
    }
</script>

<div class="root">
    <div class="activeIcon" on:click={() => activeZoneSearcherInput.focus()}>
        <span class="material-icons"> qr_code_scanner </span>
    </div>
    <div style="margin: 0 1rem;">
        <Input
            bind:nativeInput={activeZoneSearcherInput}
            bind:val={activeZoneSearcherInputVal}
            on:enter={newData}
            name={title}
            required={false}
        />
    </div>
    <button
        class="standartButton standartButton_SMargin"
        on:click={newData}>Vyhledat a přidat</button
    >
    {#if activeZoneSearcherFailTimer}
        <div class="standartdMesageCentered">
            <div class="standartFilledMesage warningColors">
                <span class="material-icons"> warning_amber </span>
                <span>{searchFailMsg}</span>
            </div>
        </div>
    {/if}
</div>

<style>
    .root {
        display: flex;
        align-items: center;
    }
</style>
